import React from "react";
import {Dialog, DownloadIcon, IconButton, Pane, Paragraph, RemoveIcon, Table, toaster, Tooltip} from "evergreen-ui";
import {deleteFileVersion, getFileByMaterialIdAndVersion} from "../Api";
import {getFileNameFromContentDisposition} from "../../Constructor/common/ApiCommon";
import {useSelector} from "react-redux";
import {getArchiveElementsRights} from "../../Privileges/PrivilegesSelectors";

export default function MaterialVersionsDialog({isShown, setIsShown, versions, setVersions, onClose}) {

    const privileges = useSelector(state => state.login.privileges)
    const rights = getArchiveElementsRights(privileges)

    function onDelete(version) {
        const newFiles = versions.files.filter(file => file.version !== version)
        const newVersions = {...versions, files: newFiles}
        setVersions(newVersions)

        if (newVersions.files.length === 0) {
            setIsShown(false)
        }
    }

    function onDownloadButton(materialsId, filename, version) {
        version = version == undefined ? '' : version

        getFileByMaterialIdAndVersion(materialsId, version).then((response) => {
            const filename = getFileNameFromContentDisposition(response.headers['content-disposition'])
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            toaster.success('Успешно создали!')
        });
    }

    const [removeDialog, setRemoveDialog] = React.useState(false)
    const [fileVersion, setFileVersion] = React.useState()

    return (
        <Dialog
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEscapePress={false}
            width={1400}
            isShown={isShown}
            hasCancel={false}
            confirmLabel={"Закрыть"}
            onCancel={() => setIsShown(false)}
            onCloseComplete={() => {
                onClose()
                setIsShown(false)
            }}
            title="Журнал версий"
        >
            <Pane>
                <Paragraph><b>Название: </b> {versions.length != 0? versions.name : ''}</Paragraph>
                <Paragraph><b>Станция: </b> {versions.length != 0? versions.station.name : ''}</Paragraph>
                <Paragraph><b>Год: </b> {versions.length != 0? versions.year : ''}</Paragraph>
                <Table marginTop={18}>
                    <Table.Head>
                        <Table.TextHeaderCell>Номер</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Изменено</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Автор изменений</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Заметки</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Меню</Table.TextHeaderCell>
                    </Table.Head>
                    <Table.Body>
                        {
                            versions.length !== 0 ?

                                versions.files.map((file, index) =>
                                    <Table.Row>
                                        <Table.Cell>{file.version}</Table.Cell>
                                        <Table.Cell>{file.createDate}</Table.Cell>
                                        <Table.Cell>{file.author}</Table.Cell>
                                        <Table.Cell>{file.notes}</Table.Cell>
                                        <Table.Cell gap={5}>
                                            <Tooltip content="Скачать">
                                                <IconButton icon={DownloadIcon} onClick={() => onDownloadButton(
                                                    versions.materialsId,
                                                    versions.name,
                                                    file.version)}
                                                />
                                            </Tooltip>
                                            {
                                                rights.canRemove ?
                                                    <Tooltip content="Удалить">
                                                        <IconButton icon={RemoveIcon} onClick={
                                                            () => {
                                                                setFileVersion(file.version)
                                                                setRemoveDialog(true)
                                                            }
                                                        }/>
                                                    </Tooltip> : <></>
                                            }

                                        </Table.Cell>
                                    </Table.Row>
                                )
                                : ''
                        }
                    </Table.Body>
                </Table>
            </Pane>
            <Dialog
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEscapePress={false}
                width={700}
                intent="danger"
                onConfirm={() => {
                    deleteFileVersion(versions.materialsId, fileVersion).then(
                        (res) => {
                            onDelete(fileVersion)
                            toaster.success("Файл был успешно удален!")
                            setRemoveDialog(false)
                        }
                    )
                }}
                onCancel={() => setRemoveDialog(false)}
                isShown={removeDialog}
                title="Удалить версию"
                cancelLabel="Отмена"
                confirmLabel="Да"
            >
                <Pane>
                    <Paragraph>Версия файла №{fileVersion} будет удалена. Продолжить?</Paragraph>
                </Pane>
            </Dialog>
        </Dialog>
    )
}